import { BaseDto } from 'src/dtos/common/baseDto';
import { MenuDto } from 'src/dtos/menu/menuDto';

/**
 * 메뉴 관리 데이터를 위한 내부 확장 인터페이스
 * inserted: 새로 생성된 데이터 여부
 * isModified: 수정된 데이터 여부
 */
export interface SYS2010_R01Dto extends MenuDto, BaseDto {
    inserted: boolean;
    isModified: boolean;
}
/**
 * 메뉴 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSYS2010_R01Dto: SYS2010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
    menuCd: '',
    menuNm: '',
    upMenu: '',
    useYn: 'Y',
    displayOnly: 'N',
    menuLevel: 1,
    menuSeq: 1,
    devloper: '',
    queryAut: 'Y',
    insertAut: 'Y',
    deleteAut: 'Y',
    saveAut: 'Y',
    printAut: 'Y',
    excelAut: 'Y',
    devSts: 0,
	manualPage: 1,
    remark: '',
    subMenu: [],
    inserted: false,
    isModified: false
};